import { useEffect, useState } from "react"
import { _CreditProcessMovement, _single } from "../../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../../core/services/dataBean/useDataBean"
import { AccountEditor } from "../../../editor/AccountEditor"
import { BasicPage } from "../../../theme/Component/BasicPage"
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable"
import { toast } from "react-toastify"
import { YearSelector } from "../../../../core/shared/inputs/YearSelector"
import { SelectMonths } from "../../../contract/select/SelectMonths"
import { CompanyEditor } from "../../../erp/cellEditor/Company/CompanyEditor"
import { SelectPayrollFactor } from "../../../custom/forpo/components/Credit/Procesos/SelectPayrollFactor"
import { BasicButton } from "../../../theme/Component/BasicButton"

interface Parameters {
    Year: number;
    Month: number;
    IDEmployee?: number;
    IDCompany?: number;
    IDPayrollFactor?: number;
}

export const ReportDiscountsByEmployee = () => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_CreditProcessMovement);
    const [param, setParam] = useState<Parameters>({
        Month: _single.getCurrentMonth(),
        Year: _single.getCurrenYear()
    })

    const getLista = () => {
        instance.getPayrollDeductionsForCreditQuota(param.Year, param.Month, param.IDEmployee, param.IDPayrollFactor).then(
            (resp) => {
                let temp:any=[];
                resp.forEach(element => {
                    
                    temp.push({
                        DataBeanProperties:element
                    })
                });
                console.log(temp);
                setLista(temp)
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'ID Empleado', property: 'EmployeeID', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre Empleado', property: 'EmployeeName', visible: true },
        { title: 'Valor', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Unidad de Negocio', property: 'IDBusinessCore', visible: true },
        { title: 'Cuenta de Descuento', property: 'AccountantIDName', visible: true },
    ]


    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            getLista()
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "Year", "Month", "IDPayrollFactor"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (param[field] === null || param[field] === undefined || param[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <BasicPage titulo="Reporte de Descuentos de Nómina por Empleado" >
            <div className="row">
                <div className="col-md-3">
                    <label className={`${missingFields.includes('Year') ? 'has-error' : ''}`}>Vigencia</label>
                    <YearSelector value={param.Year} onChange={(e) => { setParam({ ...param, "Year": e }) }} />
                </div>
                <div className="col-md-3">
                    <label className={`${missingFields.includes('Month') ? 'has-error' : ''}`}>Mes</label>
                    <SelectMonths label=" " idSelector={param.Month} onChange={(e) => { setParam({ ...param, "Month": e }) }} />
                </div>
                <div className="col-md-6">
                    <AccountEditor idAccount={param.IDEmployee} label="Empleado" onChange={(e) => { setParam({ ...param, IDEmployee: e.IDAccount }) }} />
                </div>
                <div className="col-md-6">
                    <CompanyEditor id={param.IDCompany} onchange={(e) => { setParam({ ...param, "IDCompany": e, IDPayrollFactor: null }) }} />
                </div>
                <div className="col-md-6">
                    <label className={`${missingFields.includes('IDPayrollFactor') ? 'has-error' : ''}`}>Payroll a Aplicar</label>
                    <SelectPayrollFactor idCompany={param.IDCompany} idSelector={param.IDPayrollFactor} onChange={(e) => { setParam({ ...param, IDPayrollFactor: e }) }} label=" " />
                </div>
                <div className="col-md-4 mt-4">
                    <BasicButton eventClick={validateData} icon="ri-search-line" children={`Buscar`} />
                </div>
            </div>
            <BasicTable body={lista} head={head} rowSet={setBean} />
        </BasicPage>
    )
}